var _mask, _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamsEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 56,
    viewBox: "0 0 377 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1046_7976",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H376.5V56H0.5V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H376.5V56H0.5V0Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20,
    width: 48,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 20,
    width: 48,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 20,
    width: 48,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 20,
    width: 48,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 308.5,
    y: 20,
    width: 48,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.5 55H0.5V57H376.5V55Z",
    fill: "#EFEFEF",
    mask: "url(#path-1-inside-1_1046_7976)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsEmptyState);
export default __webpack_public_path__ + "static/media/teams-empty-state.704960e4f419b4e8eb4393fdd5e9fb46.svg";
export { ForwardRef as ReactComponent };